module.exports = __webpack_public_path__ + "img/miset3a.202a87eb.jpg";